import { animate, style, transition, trigger } from '@angular/animations';

export const copyFadeIn = trigger('copyFadeIn', [
  transition(':enter', [
    style({
      opacity: 0
    }),
    animate(
      '.8s ease-in',
      style({
        opacity: 1
      })
    )
  ])
]);
